import { createFileRoute } from '@tanstack/react-router';
import { ConnectionsList } from '@/features/meta-omnichannel/components/ConnectionsList';
import { WhatsAppUsagePanel } from '@/features/meta-omnichannel/components/WhatsAppUsagePanel';
import { WhatsAppTemplatesManager } from '@/features/meta-omnichannel/components/WhatsAppTemplatesManager';

export const Route = createFileRoute('/_authenticated/meta-omnichannel-config')({
  component: MetaOmnichannelConfigPage,
});

function MetaOmnichannelConfigPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Omnicanal — Canais Conectados</h1>
        <p className="text-muted-foreground mt-1">
          Conecte e gerencie os canais Meta desta conta (Facebook, Instagram, WhatsApp Business).
        </p>
      </div>
      <ConnectionsList />
      <WhatsAppTemplatesManager />
      <WhatsAppUsagePanel />
    </div>
  );
}
